module.exports = __webpack_public_path__ + "img/tab-content-02.7fe7018d.jpg";